import { createContext } from 'react';

const BottomDrawerContext = createContext();

export const BottomDrawerProvider = BottomDrawerContext.Provider;
export default BottomDrawerContext;
